import React, {useMemo} from "react"
import { Layout } from "./Layout";
import {useSiren} from "./SirenContext";
import {ContactGroupCreate} from "./subpages/ContactGroupCreate";
import { ContactGroupList } from "./subpages/ContactGroupList";
import {TemplateCreate} from "./subpages/TemplateCreate";
import {TemplateList} from "./subpages/TemplateList";

export function Templates() {
    const {subMenuCurrent} = useSiren()

    const page = useMemo(() => {
        switch (subMenuCurrent) {
            case "create": return <TemplateCreate/>
            case "alert": return <TemplateList type="alert"/>
            case "message": return <TemplateList type="message"/>
        }

        return null
    },[subMenuCurrent])


    return (
        <Layout menuCurrent={"templates"} >
            {page}
        </Layout>
    )



}